import React, { FC, ReactNode } from "react";
import styled from "styled-components";

import { vwMobile, vwDesktop } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import ButtonLink from "../shared/ButtonLink";
import { Image } from "../../types";

export type CardProps = {
  image: Image;
  button?: { label: string; link: string };
  children: ReactNode;
};

const Card: FC<CardProps> = ({ image, button, children }: CardProps) => {
  return (
    <Container>
      <Logo src={image?.src} alt={image?.alt} />
      {children}
      {button && <StyledButton label={button?.label} link={button?.link} />}
    </Container>
  );
};

const Container = styled.div`
  background-color: #012102;
  display: flex;
  flex-direction: column;
  min-height: ${vwMobile(402)};
  padding: ${vwMobile(20)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    min-height: ${vwDesktop(442)};
    padding: ${vwDesktop(40)};
  }
`;

const Logo = styled.img`
  height: ${vwMobile(88)};
  margin-bottom: ${vwMobile(20)};
  width: ${vwMobile(88)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: ${vwDesktop(88)};
    margin-bottom: ${vwDesktop(20)};
    width: ${vwDesktop(88)};
  }
`;

const StyledButton = styled(ButtonLink)`
  margin-top: auto;
  margin-right: auto;
  width: ${vwMobile(180)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: ${vwDesktop(180)};
  }
`;

export default Card;
